module.exports = __webpack_public_path__ + "img/home-big.1fd2e25.png";